<template>
  <div class="layout-container"  :class="col.options.waterFlow?'layout-container-waterFlow':''" style="width: 100%" ref="layoutContainer">
    <div
      v-for="handle in borderHandles"
      :key="handle"
      :class="['handle', 'handle-' + handle]"
      @click.stop="activeLayoutCell($event, 'resize')"
    >
      <slot :name="handle"></slot>
    </div>
    <draggable
      v-if="col.layout.rows && col.layout.rows.length > 0"
      class="layout-row-container"
      element="div"
      v-model="col.layout.rows"
      :handle="'.submover'"
      ghostClass="ghostClass"
      dragClass="dragClass"
      :forceFallback="true"
      @change="changeOrder"
      :id="'layout_' + layoutIndex"
      @click.native.stop="activeLayoutCell($event, 'resize')"
      @mouseenter.native.prevent="activeLayout($event, col)"
      @mouseleave.native.prevent="deactivated($event)"
    >
      <div
        class="layout-row layout-box"
        v-for="(subCol, subIndex) in col.layout.rows"
        :key="layoutIndex + '_' + subCol.id"
        :style="getColBoxStyle(subCol, 'row', subIndex, col.layout.rows.length)"
        :class="[
          !isShowTabs || (isShowTabs && (layoutLevel !== 3 || (layoutLevel === 3 && subIndex === activeIndex)))
            ? ''
            : 'hidden',
          subCol.options.showRowColLayout ? subCol.options.rowColDirection !== 'horizon' ?
          'row-col-layout vertical-layout' : 'row-col-layout horizon-layout' : ''
        ]"
      >
        <layout-tree
          :isAnchor="isAnchor"
          :baseComponent="baseComponent"
          :col="subCol"
          :layoutIndex="layoutIndex + '_' + subIndex"
          :zoom="zoom"
          :curIndex="subIndex"
          :parentLayout="col.layout"
          :id="id"
          :options="options"
          :isWaterFall="isWaterFall"
          :isAccordionLayout="isAccordionLayout"
          :openIndex="openIndex"
        ></layout-tree>
      </div>
    </draggable>
    <!--带有竖向标签的通栏isShowVerticalTabs curIndex为1时需要根据activeIndex显示隐藏 -->
    <draggable
      v-else-if="col.layout.cols && col.layout.cols.length > 0"
      element="div"
      v-model="col.layout.cols"
      ghostClass="ghostClass"
      dragClass="dragClass"
      :forceFallback="true"
      :handle="'.submover'"
      @change="changeOrder"
      class="layout-col-container"
      :id="'layout_' + layoutIndex"
      @click.native.stop="activeLayoutCell($event, 'resize')"
      @mouseenter.native.prevent="activeLayout($event, col)"
      @mouseleave.native.prevent="deactivated($event)"
      :isAnchor="isAnchor"
      :style="getColContainerStyle(col)"
    >
      <div
        class="layout-col layout-box"
        :class="[
          !isShowVerticalTabs ||
          (isShowVerticalTabs && (layoutLevel !== 4 || (layoutLevel === 4 && subIndex === activeIndex)))
            ? ''
            : 'hidden',
          subCol.options.childSizeAuto && subCol.rectIds && subCol.rectIds.length > 0 ? 'no-size-limit' : '',
          subCol.options.showAutoLayout && !subCol.options.direction
            ? 'vertical'
            : subCol.options.direction
            ? subCol.options.direction
            : '',
          subCol.options.showRowColLayout ? subCol.options.rowColDirection !== 'horizon' ?
          'row-col-layout vertical-layout' : 'row-col-layout horizon-layout' : '',
          isAccordionLayout ? 'transition' : ''
        ]"
        v-for="(subCol, subIndex) in col.layout.cols"
        :key="layoutIndex + '_' + subCol.id"
        :style="getColBoxStyle(subCol, '', subIndex)"
        v-stick="{ positionType: subCol.options.positionType, stickyTop: subCol.options.positionType === 'sticky' ? (subCol.options.pxOffset[0] === '自动' ? 0 : subCol.options.pxOffset[0]): 0 }"
      >
        <layout-tree
          :baseComponent="baseComponent"
          :col="subCol"
          :layoutIndex="layoutIndex + '_' + subIndex"
          :zoom="zoom"
          :curIndex="subIndex"
          :parentLayout="col.layout"
          :id="id"
          :options="options"
          :isAnchor="isAnchor"
          :isWaterFall="isWaterFall"
          :isAccordionLayout="isAccordionLayout"
          :openIndex="openIndex"
        ></layout-tree>
      </div>
    </draggable>
    <div
      v-else
      class="layout-columns"
      :layoutindex="layoutIndex"
      :id="'layout_' + layoutIndex"
      @mouseenter.prevent="activeLayout($event, col)"
      @mouseleave.prevent="deactivated($event)"
      @click.stop="activeLayoutCell($event, 'resize')"
      :style="getColStyle(col)"
    >
      <layout-cell
        :baseComponent="baseComponent"
        ref="cell"
        :rect.sync="col.rectIds"
        :layout="col"
        :zoom="zoom"
        :layoutIndex="layoutIndex"
        :curIndex="layoutIndex"
        :curId="curId"
        @changeCellSize="changeCellSize"
        @activeLayoutCell="activeLayoutCell($event)"
        :id="id"
        :allLayout="allLayout"
        :isAnchor="isAnchor"
        :index="curIndex"
        :isAccordionLayout="isAccordionLayout"
        :openIndex="openIndex"
      ></layout-cell>
    </div>
    <div class="layout-sets" @mouseenter.stop="activeLayout($event, col)" v-if="!isBigScreenPreview() && !isPopover">
      <cell-sets
        v-show="!isResizing"
        :parentLayout.sync="parentLayout"
        :cell.sync="col"
        :curIndex="curIndex"
        :layoutIndex="layoutIndex"
        @reWriteRect="reCalcRect"
        @setParentLayoutH="setParentLayoutH"
        :id="id"
        :offsetTop="offsetTop"
        :offsetHeight="offsetHeight"
        :isShowVerticalTabs="isShowVerticalTabs"
        :isShowTabs="isShowTabs"
        :layoutLevel="layoutLevel"
        :isAnchor="isAnchor"
        :isWaterFall="isWaterFall"
        :isAccordionLayout="isAccordionLayout"
        :openIndex="openIndex"
      ></cell-sets>
    </div>
    <div
      class="resize_handle resize-handle-left"
      v-if="!isBigScreenPreview() && parentLayout.cols && parentLayout.cols.length > 1 && curIndex > 0 && !isAccordionLayout"
      @click.stop="activeLayoutCell($event, 'resize')"
      @mouseenter.stop="handleMouseenter($event)"
      @mouseleave.prevent="deactivated($event)"
      @mousedown.stop="
        $myDrag(
          {
            ctx: _self,
            dragStart: e => resizeStartEv(col, e, 'left'),
            dragging: e => resizingEv(col, e, 'left'),
            dragEnd: e => resizeStopEv(col, e)
          },
          $event
        )
      "
    >
      <span
        v-show="isResizing && resizingHandleDirection === 'left'"
        class="size"
        :class="[judgeIsTop ? '' : 'is-bottom', offsetTop < 50 ? 'is-down' : '']"
        >{{ Math.round(parseFloat(bortherW)) }}% <span class="split-line">|</span
        >{{ Math.round(parseFloat(col.options.width)) }}%</span
      >
    </div>
    <div
      class="resize_handle resize-handle-right"
      v-if="
        !isBigScreenPreview() &&
        parentLayout.cols &&
        parentLayout.cols.length > 1 &&
        curIndex < parentLayout.cols.length - 1 &&
        (!isShowVerticalTabs ||
          (isShowVerticalTabs && layoutLevel !== 5)) && !isAccordionLayout
      "
      @click.stop="activeLayoutCell($event, 'resize')"
      @mouseenter.stop="handleMouseenter($event)"
      @mouseleave.prevent="deactivated($event)"
      @mousedown.stop="
        $myDrag(
          {
            ctx: _self,
            dragStart: e => resizeStartEv(col, e, 'right'),
            dragging: e => resizingEv(col, e, 'right'),
            dragEnd: e => resizeStopEv(col, e)
          },
          $event
        )
      "
    >
      <span
        v-show="isResizing && resizingHandleDirection === 'right'"
        class="size"
        :class="[judgeIsTop ? '' : 'is-bottom', offsetTop < 50 ? 'is-down' : '']"
        >{{ Math.round(parseFloat(col.options.width)) }}%<span class="split-line">|</span
        >{{ Math.round(parseFloat(bortherW)) }}%</span
      >
    </div>
    <!--只有行才能拖拽高度-->
    <div
      class="resize_handle resize-handle-bottom"
      v-if="!isBigScreenPreview() && showBottomResizeHandle"
      @click.stop="activeLayoutCell($event, 'resize')"
      @mouseenter.stop="handleMouseenter($event)"
      @mouseleave.prevent="deactivated($event)"
      @mousedown.stop="
        $myDrag(
          {
            ctx: _self,
            dragStart: e => heightResizeStartEv(col, e),
            dragging: e => heightResizingEv(col, e),
            dragEnd: e => heightResizeStopEv(col, e)
          },
          $event
        )
      "
    ></div>
  </div>
</template>

<script>
import layoutCell from "./cell"
import draggable from "vuedraggable"
import $ from "jquery"
import { _throttle } from "utils"
import { deepCloneAndFreeze } from "utils/revork"
import cellSets from "./cellSets"
import { addEvent, removeEvent } from "utils/dom"

import { primaryBigScreenPageLayoutGenerator as primarybigScreenPageLayoutGenerator } from "store/modules/bigScreen/state"
import { primaryStagePageLayoutGenerator as primarystagePageLayoutGenerator } from "store/modules/stage/state"
import { primaryappStagePageLayoutGenerator as primaryappStagePageLayoutGenerator } from "store/modules/appStage/state"

const mockData = {
  primarybigScreenPageLayoutGenerator,
  primarystagePageLayoutGenerator,
  primaryappStagePageLayoutGenerator
}

export default {
  name: "layout-tree",
  components: {
    draggable,
    layoutCell,
    cellSets
  },
  data() {
    return {
      textOptions: {
        type: Array,
        default: []
      },
      activeTabId: "",
      appId: null,
      pageId: null,
      restDataUrl: null,
      typeVal: null,
      websiteId: null,
      wfwfid: null,
      colsIdFromActiveRect: [],
      cacheDataTypes: [],
      testData: [1, 2, 4],
      _self: this,
      resizeStartSite: null,
      // activeIndex: undefined,
      paddingDragging: false,
      resizeSite: null,
      parentW: null,
      bortherW: null,
      isResizing: false,
      resizingHandleDirection: null,
      borderList: ["tb", "rb", "bb", "lb"],
      isShowBorder: false,
      offsetTop: 0,
      offsetHeight: 0
    }
  },
  props: {
    curId: [String, Number],
    isAnchor: {
      type: Boolean,
      default: false
    },
    baseComponent: {
      type: Array
    },
    options: {
      type: Object,
      default: null
    },
    zoom: {
      type: Number,
      default: 1
    },
    myid: {
      type: Object,
      default: null
    },
    rect: {
      type: Object
    },
    parentLayout: {
      type: Object,
      required: true
    },
    layoutIndex: {
      type: [Number, String],
      required: true
    },
    curIndex: {
      type: [Number, String],
      required: true
    },
    id: {
      type: Number
    },
    col: {
      type: Object,
      required: true
    },
    allLayout: {
      type: Object
    },
    isWaterFall:{
      type:Boolean,
      required:true
    },
    isAccordionLayout: {
      type: Boolean,
      required: true
    },
    openIndex: {
      type: Number,
      required: true
    },
  },
  watch: {
    "ids.pageLayoutId": {
      deep: true,
      handler(n, o) {
        if (n != o) {
          this.changeBtnPosition()
        }
      }
    }
  },
  computed: {
    activeIndex() {
      return this.options?.activeIndex || 0
    },
    // 是否是横向标签布局标志
    isShowTabs() {
      return this.options?.isShowTabs || false
    },
    // 是否是竖向标签布局标志
    isShowVerticalTabs() {
      return this.options?.isShowVerticalTabs || false
    },
    ids() {
      return this.$store.state.states.activeID
    },
    isElementInLayout() {
      return (
        this.ids.hasOwnProperty("elementInLayoutId") ||
        this.ids.hasOwnProperty("uid") ||
        this.ids.hasOwnProperty("directionIndexOther")
      )
    },
    showBottomResizeHandle() {
      if (this.request_prefix === "bigScreen") {
        return this.parentLayout.rows.length > 1 && this.curIndex < this.parentLayout.rows.length - 1
      } else {
        return (
          this.parentLayout.rows.length > 0 &&
          this.curIndex < this.parentLayout.rows.length &&
          !this.options.enableBayWindow &&
          !this.col.options.isFullHeight && // 如果当前布局设置了占满屏幕高度，则不允许拖拽调整高度
          !this.col.options.waterFlow &&
          this.options.inDocument !== "popover"
        )
      }
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    layoutLevel() {
      // let pageLayoutId = this.ids.pageLayoutId
      let pageLayoutId = this.layoutIndex
      let layoutIds = pageLayoutId?.toString().split("_")
      return layoutIds?.length
    },
    layoutCols: {
      get() {
        return this.layout
      },
      set(val) {
        this.$emit("update:layout", val)
      }
    },
    getRowStyle() {
      // 通栏的样式
      let options = this.layout.options
      let pageWidth = this.$store.state[this.request_prefix].page.pageWidth
      return {
        width: pageWidth + "px",
        // height: options.height + "px",
        opacity: options.opacity / 100,
        margin: "0 auto"
      }
    },
    colBgStyle() {
      return function (col, index) {
        let options = col.options
        if (!options) {
          return {}
        }
        let containerBg = {
          backgroundImage: ""
        }
        let bg = options.bg
        if (this.isAccordionLayout && this.openIndex === index) {
          bg = options.activeBackground
        }
        if (!bg || !Array.isArray(bg)) {
          return {}
        }
        bg.forEach(bg => {
          switch (bg.type) {
            case "img":
              let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
              break
            case "color":
              containerBg.backgroundColor = this.$parseColor(bg)
              break
            case "linearGradient":
              let tmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  tmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                containerBg.backgroundImage += dot + this.$parseColor(bg)
                containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
                containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
                containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
              }
              break
            case "radialGradient":
              let radialTmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  radialTmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                containerBg.backgroundImage +=
                  dot + this.$parseColor(bg)
                containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
                containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
                containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
              }
              break
            default:
          }
        })
        return containerBg
      }
    },
    getColBoxStyle() {
      return function (col, cellType, index, colLength) {
        let borderW = ""
        if (Array.isArray(col.options.borderWidth)) {
          col.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        } else {
          borderW += ` ${col.options.borderWidth}px`
        }
        let margin = "",
          marginHorizon = 0
        Array.isArray(col.options.colMargin) &&
          col.options.colMargin.forEach((item, index) => {
            if (index === 1 || index === 3) {
              marginHorizon += item
            }
            margin += item + "px "
          })
        let zIndex = null
        if (cellType === "row") {
          // 行之间设置层级
          zIndex = colLength.length - index
        }
        let bgStyle =  this.colBgStyle(col, index)
        let showBorder =
          (col.layout?.rows && col.layout.rows.length > 0) || (col.layout?.cols && col.layout.cols.length > 0)
        let colWidth = `calc(${col.options.width} - ${marginHorizon}px)`
        let maxHeight = (col.options.heightType === "%" ? (col.options.height / 100) * window.innerHeight : col.options.height !== 0 && col.options.heightType !== "自动" ? col.options.height : "") +
        "px" // 最大值-- 设置了内边距和外边距加起来超过布局高度的情况设置的最大高度
        let borderRadius = col.options.borderRadius
        let heightStyle = {}
        if (this.isAccordionLayout) {// 手风琴布局
          const { activeWidth, defaultWidth } = this.options
          colWidth =  defaultWidth + "%"
          heightStyle = {
            height: col.options.heightType === "%" ? "100%" : col.options.height + "px"
          }
          if (this.openIndex === index) {
            maxHeight = col.options?.activeHeightType === "%" ? "100%" : col.options?.hasOwnProperty("activeHeight") ? col.options.activeHeight + "px" : col.options.height + "px"
            colWidth = activeWidth + "%"
            borderRadius = col.options.activeBorderRadius || [0,0,0,0]
            heightStyle = {
              height: maxHeight
            }
          }
        }
        return {
          ...bgStyle,
          ...heightStyle,
          ...this.publicStyle(col),
          display: typeof col.options.isShow === "boolean" && !col.options.isShow ? "none" : "flex",
          width: colWidth,
          // 最大高度是极限情况下才需要 容易引起子页面高度塌陷 先去掉
          // maxHeight: maxHeight,
          // height: col.options.height + "px",
          margin: margin,
          zIndex: zIndex,
          "border-style": col.options.borderStyle,
          "border-color": this.$parseColor(col.options.borderColor, {
            isThemeColor: col.options.borderIsThemeColor
          }),
          "border-width": showBorder ? borderW : 0,
          "border-radius": `${borderRadius[0]}px ${borderRadius[1]}px ${borderRadius[2]}px ${borderRadius[3]}px`,
          "--custom-margin": col.options?.marginBottom ? col.options?.marginBottom + "px" : ""
        }
      }
    },
    getColStyle() {
      return function (col) {
        let borderW = ""
        if (Array.isArray(col.options.borderWidth)) {
          col.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        } else {
          borderW += ` ${col.options.borderWidth}px`
        }
        let padding = ""
        if (Array.isArray(col.options.padding)) {
          col.options.padding.forEach(item => {
            padding += item + "px "
          })
        }else if(col.options.padding){
          padding = col.options.padding + "px "
        }
        let bgStyle = this.colBgStyle(col, this.curIndex)
        let boxShadowStyle = this.boxShadowStyle(col.options)
        let marginVertical = 0
        Array.isArray(col.options.colMargin) &&
          col.options.colMargin.forEach((item, index) => {
            if (index === 0 || index === 2) {
              marginVertical += item
            }
          })
        let height = this.options.enableBayWindow ? "100%" :
          col.options.heightType === "%" ? `calc(${col.options.height}vh - ${marginVertical}px)` : col.options.heightType === "自动" ? "auto" : (col.options.height - marginVertical) + "px"
        const maxHeight = col.options.heightType === "自动" && col.options.showMaxHeight? col.options.maxHeight + "px" : ""
        const minHeight = col.options.heightType === "自动" && col.options.showMinHeight ? col.options.minHeight + "px" : ""
        if (col.options.heightType === "自动") {
          // 如果当前通栏高度自适应，内部元素为空，设置默认高度避免高度为0选不中布局
          if (!col.rectIds.length) {
            this.$changeOptionsEV("px", "heightType", false, "", {
              container_id: this.ids.container_id,
              pageLayoutId: this.layoutIndex
            }, true)
            this.$changeOptionsEV(200, "height", false, "", {
              container_id: this.ids.container_id,
              pageLayoutId: this.layoutIndex
            }, true)
            height = 200 + "px"
          } else {
            // 当前布局下的所有元素都是高度充满，且没有填充子元素
            let noHeight = col.rectIds.every(item => {
              let rect = this.getAttrById.call(
                this,
                this.$store.state[this.request_prefix],
                {
                  container_id: this.ids.container_id || 0,
                  rect_id: item
                },
                "rect"
              )
              let noElement = !rect.options.elementOptions || rect.options.elementOptions.length === 0
              return rect.options.heightType === "%" && noElement
            })
            if (noHeight) {
              this.$changeOptionsEV("px", "heightType", false, "", {
                container_id: this.ids.container_id,
                pageLayoutId: this.layoutIndex
              }, true)
              this.$changeOptionsEV(200, "height", false, "", {
                container_id: this.ids.container_id,
                pageLayoutId: this.layoutIndex
              }, true)
              height = 200 + "px"
            }
          }
        }
        if (col.options.waterFlow) {
          height = 'auto'
        }
        return {
          ...bgStyle,
          boxShadow: boxShadowStyle,
          width: col.options.width,
          height: height,
          maxHeight: maxHeight,
          minHeight: minHeight,
          padding: padding,
          opacity: col.options.opacity / 100,
          borderRadius: `${col.options.borderRadius[0]}px ${col.options.borderRadius[1]}px ${col.options.borderRadius[2]}px ${col.options.borderRadius[3]}px`,
          "border-style": col.options.borderStyle,
          "border-color": this.$parseColor(col.options.borderColor, {
            isThemeColor: col.options.borderIsThemeColor
          }),
          "border-width": col.options.showBorder !== false ? borderW : 0,
          "border-radius": `${col.options.borderRadius[0]}px ${col.options.borderRadius[1]}px ${col.options.borderRadius[2]}px ${col.options.borderRadius[3]}px`,
          outline: this.$store.state[this.request_prefix].page.isWaterFall ? col.options.gridLayout?.length>0?"none": "1px dashed var(--thirdTextColor)" : this.isBigScreenPreview() || col.rectIds.length > 0 ? "none" : "1px dashed var(--thirdTextColor)",
          ...this.activeStyle(col),
          ...this.publicStyle(col)
        }
      }
    },
    publicStyle() {
      return function (col) {
        let style = {}
        const { showBackgroundFilter, backgroundFilter } = col?.options
        if (showBackgroundFilter) {
          style.backdropFilter = `blur(${backgroundFilter}px)`
        }
        return style
      }
    },
    activeStyle() {
      return function(col) {
        if (this.isAccordionLayout) {
          let options = col.options
          const height = options.height
          if (this.openIndex !== this.curIndex) return {
            height: options?.heightType === "%" ? "100%" : height + "px"
          }
          let borderW = ""
          if (Array.isArray(options.activeBorderWidth)) {
            options.activeBorderWidth.forEach(item => [(borderW += ` ${item}px`)])
          } else {
            borderW += ` ${options.activeBorderWidth}px`
          }
          let padding = ""
          if (Array.isArray(options.activePadding)) {
            options.activePadding.forEach(item => {
              padding += item + "px "
            })
          } else if (options.activePadding) {
            padding = options.activePadding + "px "
          }
          let activeHeight = options?.activeHeightType === "%" ? "100%" : options?.hasOwnProperty("activeHeight") ? options.activeHeight + "px" : height + "px"
          let borderRadius = options?.hasOwnProperty("activeBorderRadius") ? options.activeBorderRadius : [0,0,0,0]
          return {
            width: "100%",
            height: activeHeight,
            padding: padding,
            "border-style": options.activeBorderStyle || "solid",
            "border-color": this.$parseColor(col.options.activeBorderColor, {
              isThemeColor: options.activeBorderIsThemeColor
            }),
            "border-width": col.options.activeShowBorder ? borderW : 0,
            "border-radius": `${borderRadius[0]}px ${borderRadius[1]}px ${borderRadius[2]}px ${borderRadius[3]}px`,
          }
        }
      }
    },
    borderHandles() {
      return this.borderList
    },
    headerIsFixed() {
      let pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
      let header = pageLayoutList[0].options.inDocument === "header" ? pageLayoutList[0] : undefined
      if (header) {
        return header.options.isFixed ? true : false
      }
      return false
    },
    judgeIsTop() {
      // 判断是否是第一个通栏的第一行内，此时的按钮位置朝下
      let isTop = true
      let _index = this.layoutIndex.toString().split("_")
      //根据是行还是列 列不需要判断最后一行  行需要判断最后一个
      let isRow = this.parentLayout.rows.length ? true : false
      if (!isRow) {
        _index.splice(_index.length - 1, 1)
      }
      // 头部fixed的时候  第二个通栏的设置项朝下
      let firstIndex = this.headerIsFixed ? 1 : 0
      for (let i = 0; i < _index.length; i++) {
        if (i === 0 && _index[i] != firstIndex && _index[i] != 0) {
          isTop = true
          break
        }
        if (i !== 0 && _index[i] != 0) {
          isTop = true
          break
        } else {
          isTop = false
        }
      }
      return isTop
    },
    getColContainerStyle() {
      return function(col) {
        if (this.isAccordionLayout) {
          let alignItems = "center"
          switch (col?.options?.alignmentType) {
            case "top":
              alignItems = "start"
              break;
            case "bottom":
              alignItems = "end"
              break;
          }
          let padding = ""
          col.options.padding.forEach(item => {
            padding += item + "px "
          })
          return {
            height: col.options.height + "px",
            "align-items": alignItems,
            gap: col?.options?.hasOwnProperty("accordionMargin") ?  col?.options?.accordionMargin + "px" : 0,
            padding: padding
          }
        } else {
          return {}
        }
      }
    },
    isPopover() {
      return this.options.inDocument === "popover"
    }
  },
  mounted() {
    addEvent(window, "wheel", this.changeBtnPosition, false)
  },
  beforeDestroy() {
    removeEvent(window, "wheel", this.changeBtnPosition, false)
  },
  created() {
    // 以前的通栏数据没有isShow这个属性，需要手动加上
    if (!this.col.options.hasOwnProperty("isShow")) {
      this.$changeOptionsEV(true, "isShow", false, null, {
        container_id: 0,
        pageLayoutId: this.layoutIndex
      }, true)
    }
  },
  methods: {
    changeBtnPosition(){
      let timer = setTimeout(() => {
        // 距离页面上边距 = 距离页面顶部距离 - 顶部高度50 - 刻度尺高度24
        if(this.$el && typeof this.$el !== undefined) {
          const element = this.$el.getBoundingClientRect()
          const rulerHeight = this.$store.state.states.showRuler ? 0 : 24
          this.offsetTop = element.top - 50 - rulerHeight
          this.offsetHeight = element.height
        }
        clearTimeout(timer)
      }, 200)
    },
    dragoverEv() {
      console.log("over")
    },
    changeOrder(param) {
      console.log(param)
      console.log("change 顺序")
    },
    reCalcRect(param) {
      $(".layout-container.set_active").removeClass("set_active")
      // 针对复制的单元格，重新写入组件到webJson,并替换掉当前的rect_id
      console.log(this.$refs.cell)
      this.$refs.cell?.addNewRect(param)
    },
    handleMouseenter(el) {
      console.log("handleMouseenter", this.myid)
      if ($(".layout-container.resizing").length > 0 && !$(this.$el).hasClass("resizing")) {
        // 其他布局正在拖动改变大小中
        return
      }
      if (this.$store.state.states.isClonePattern || this.$store.state.states.isOrderPattern) {
        return
      }
      let target = $(el.currentTarget)
      if (
        this.isResizing ||
        target
          .parent(".layout-container")
          .parent(".layout-col")
          .siblings(".layout-col")
          .find(".layout-container.active").length > 0 ||
        target.find(".layout-container.active").length > 0
      ) {
        return
      }
      target.parent(".layout-container").addClass("active")
      this.isShowBorder = true
      // 取消当前通栏悬浮状态
      this.pageLayout = document.querySelector(".page-layout-wrapper.hover-active")
      if (this.pageLayout) {
        this.pageLayout?.classList.remove("hover-active")
      }
    },
    activeLayout(el, col) {
      console.log("activeLayout")
        const target = $(el.currentTarget)
        // if( sessionStorage.getItem("gridMouseEnter")) return
        if (sessionStorage.getItem("isGridResizing")) return
        // 如果当前页面有正在拖拽的元素禁止触发外层hover 锚点组件禁止触发内容区
        if ($(".dragging").length > 0 || $(".isResizing").length>0 || $(".resizing").length>0 || this.isAnchor) return
        if (Object.keys(this.ids || {}).length === 0) {
          // 没有this.ids也可能是当前布局下有流式的格子处于选中状态，此种情况还是允许继续往下走
          if (!this.$refs.layoutContainer?.querySelector('.vue-grid-item.active')) return
        }
        // let target = $(el.currentTarget)
        // 判断当前选中dom的祖先元素是否有.customDrawer
        if (target.parents(".customDrawer").length > 0) {
          return
        }
        // 去掉isElementInLayout 不然选中自由布局时无法hover外层布局
        if (this.isResizing || this.$store.state.states.isClonePattern || this.$store.state.states.isOrderPattern ) {
          return
        }
        // 取消当前通栏悬浮状态
        this.pageLayout = document.querySelector(".page-layout-wrapper.hover-active")
        if (this.pageLayout) {
          this.pageLayout?.classList.remove("hover-active")
        }
        // 取消当前布局active状态
        this.layout = document.querySelector(".layout-container.active")
        if (this.layout) {
          this.layout?.classList.remove("active")
        }
        // 取消自由布局中单元格的悬浮状态主要在详情页遇到
        this.$changeOptionsEV("", "activeCol", false, null, {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        }, true)
        // 根布局允许悬浮和选中 -- 一帆提的
        // if (!col.options.waterFlow) {// 栅格布局外层不需要直接悬浮选中 一帆提的
        target.parent(".layout-container").addClass("active")
        // }
        this.isShowBorder = true
        this.bortherW = null
        // this.offsetTop = this.$el.getBoundingClientRect().top - 50
    },
    deactivated(el) {
      // 如果当前页面有正在拖拽的元素禁止触发外层hover
      if ($(this.$el).hasClass("resizing") || $(".dragging").length > 0) {
        // 当前布局正在拖动改变大小中
        return
      }
      // 鼠标移出元素 将父级元素的选中态加上
      if (this.pageLayout) this.pageLayout.classList.add("hover-active")
      this.pageLayout = undefined
      if (this.isResizing) {
        return
      }
      let target = $(el.currentTarget)
      // 设置项没有打开的情况才取消激活状态，否则点击空白区域取消激活状态
      if (!target.parent(".layout-container").hasClass("set_active")) {
        target.parent(".layout-container").removeClass("active")
        this.isShowBorder = false
      }
    },
    // 左右拖拽单元格开始
    resizeStartEv(col, e, handleDirection) {
      if ($(".layout-container.resizing").length > 0) {
        // 当前其他布局正在拖拽改变大小
        return
      }
      this.before = this.getQuickShot()
      $(this.$el).addClass("resizing")
      this.isResizing = true
      this.resizingHandleDirection = handleDirection
      $(e.target).find(".size").show()
      this.resizeSite = {
        left: e.clientX
      }
      let _thisCell = this.$el.getBoundingClientRect().width
      // 根据当前元素的宽度百分比获取父元素的宽度
      this.parentW = (_thisCell / parseFloat(col.options.width)) * 100
      let bortherCellIndex = handleDirection === "left" ? this.curIndex - 1 : this.curIndex + 1
      this.bortherW = parseFloat(this.parentLayout.cols[bortherCellIndex].options.width)
      // this.offsetTop = this.$el.getBoundingClientRect().top - 50
    },
    resizingEv: _throttle(function (col, e, handleDirection) {
      // handleDirection 手柄的位置
      let diff = e.clientX - this.resizeSite.left
      diff = handleDirection === "left" ? -diff : diff
      // 先将width 百分比换算为px   计算完后换成100%
      // 当前元素宽度改变后，兄弟元素也要改变
      let newValPx = (parseFloat(col.options.width) * this.parentW) / 100 + diff
      let newVal = (newValPx / this.parentW) * 100

      // bortherDiff>0 向右拖动, 左边兄弟元素尺寸变大
      // bortherDiff<0 向左拖动，左边兄弟元素尺寸变
      let bortherDiff = newVal - parseFloat(col.options.width)
      let layoutIds = this.layoutIndex.toString().split("_")
      let borderIndex = handleDirection === "left" ? this.curIndex - 1 : this.curIndex + 1
      layoutIds[layoutIds.length - 1] = borderIndex
      layoutIds = layoutIds.join("_")
      this.bortherW = parseFloat(this.parentLayout.cols[borderIndex].options.width) - bortherDiff
      if (newVal <= 4 || this.bortherW <= 4) {
        // 每个单元格格子定义最小宽度不低于10%
        console.log("每个单元格格子定义最小宽度不低于4%")
        this.bortherW = this.bortherW > 4 ? parseFloat(this.parentLayout.cols[borderIndex].options.width) : 4
        return
      }
      let otherWidth = 0
      this.parentLayout.cols.forEach((col,index)=>{
        if(index != this.curIndex  && index != borderIndex){
          otherWidth+= parseFloat(col.options.width)
        }
      })
      console.log("otherWidth",otherWidth)
      if((otherWidth + newVal + this.bortherW) !== 100){
        // debugger
        // 对于某些时候宽度获取有差异造成，越拖差异越大
        let diff = 100 - (otherWidth + newVal + this.bortherW )
        newVal = newVal + diff/2
        this.bortherW = this.bortherW + diff/2
      }
      this.resizeSite.left = e.clientX
      this.$changeOptionsEV(newVal + "%", "width", false, "", {
        container_id: this.id,
        pageLayoutId: this.layoutIndex
      }, true)
      this.$changeOptionsEV( this.bortherW + "%", "width", false, "", {
        container_id: this.id,
        pageLayoutId: layoutIds
      }, true)
    }, 5),
    // 拖拽单元格结束
    resizeStopEv(col, e) {
      $(this.$el).removeClass("resizing")
      $(e.target).find(".size").hide()
      this.isResizing = false
      this.resizeSite = null
      this.resizingHandleDirection = null
      const newData = this.getQuickShot()
      this.$addHistory({
        type: "update",
        stateType: "updateRect",
        payload: {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        },
        before: this.before,
        data: newData
      })
      this.before = null
    },
    // 上下拖拽单元格开始
    heightResizeStartEv(col, e) {
      this.isResizing = true
      this.resizeSite = {
        top: e.clientY
      }
      // let _thisCell= this.$el.getBoundingClientRect().height
      // // 根据当前元素的宽度百分比获取父元素的宽度
      // this.parentH = _thisCell/ parseFloat(col.options.height) * 100
    },
    heightResizingEv: _throttle(function (col, e, handleDirection) {
      // handleDirection 手柄的位置
      let diff = (e.clientY - this.resizeSite.top) / this.zoom
      // 先将width 百分比换算为px   计算完后换成100%
      // 当前元素宽度改变后，兄弟元素也要改变
      let newVal = parseFloat(col.options.height) + diff
      this.resizeSite.top = e.clientY
      // 判断是否是最后一个元素
      let layoutIds = this.layoutIndex.toString().split("_")
      let parentId = JSON.parse(JSON.stringify(layoutIds))
      parentId.splice(layoutIds.length - 1, 1)
      parentId = parentId.join("_")
      let borderIndex = this.curIndex + 1
      layoutIds[layoutIds.length - 1] = borderIndex
      layoutIds = layoutIds.join("_")
      let bortherH
      if (this.curIndex < this.parentLayout.rows.length - 1) {
        bortherH = parseFloat(this.parentLayout.rows[borderIndex].options.height) - diff
      }
      if (newVal <= 20 || (bortherH && bortherH <= 20)) {
        // 每个单元格格子定义最小宽度不低于10%
        console.log("每个单元格格子定义最小高度不低于20px")
        return
      }
      let curEditProp = newVal / parseFloat(col.options.height)
      this.$changeOptionsEV(newVal, "height", false, "", {
        container_id: this.id,
        pageLayoutId: this.layoutIndex
      }, true)
      this.setChildLayoutH(curEditProp, col)
      if ((!bortherH || this.layoutLevel < 4) && this.request_prefix !== "bigScreen") {
        // 最后一个元素，父元素的高度需要同步
        this.setParentLayoutH(parentId)
        return
      }
      let borderEditProp = bortherH / parseFloat(this.parentLayout.rows[borderIndex].options.height)
      this.setChildLayoutH(borderEditProp, this.parentLayout.rows[borderIndex])
      this.$changeOptionsEV(bortherH, "height", false, "", {
        container_id: this.id,
        pageLayoutId: layoutIds
      }, true)
      this.setParentLayoutH(parentId, this.curIndex)
    }, 50),
    // 拖拽单元格结束
    heightResizeStopEv(col, e) {
      this.isResizing = false
      sessionStorage.setItem("isResizing", false)
      this.resizeSite = null
      // this.parentH = null
    },
    // 设置子元素的高度
    setChildLayoutH(editProp, child) {
      if (child.layout.rows.length === 0 && child.layout.cols.length === 0) {
        // 没有子元素啦
        return
      }
      let curCellIsRow = child.layout.rows.length > 0 ? true : false
      let layout = curCellIsRow ? child.layout.rows : child.layout.cols
      layout.forEach(item => {
        item.options.height = item.options.height * editProp
        this.setChildLayoutH(editProp, item)
      })
    },
    // 设置父元素的高度
    setParentLayoutH(parentId, curIndex) {
      let parentH = 0
      let ids = parentId.split("_")
      let lastIndex = parseInt(ids[ids.length - 1])
      let parentLayout = this.getAttrById.call(
        this,
        this.$store.state[this.request_prefix],
        { container_id: this.id, pageLayoutId: parentId },
        "pageLayout"
      ).layout
      if (parentLayout.rows.length > 0) {
        parentLayout.rows.forEach(item => {
          parentH += parseFloat(item.options.height)
        })
      } else if (parentLayout.cols.length > 0) {
        parentH = parentLayout.cols[curIndex].options.height
        parentLayout.cols.forEach((item, index) => {
          if (index === curIndex) {
            return
          }
          let editProp = parentH / item.options.height
          item.options.height = parentH
          this.setChildLayoutH(editProp, item)
        })
      } else {
        return
      }
      this.$changeOptionsEV(parentH, "height", false, "", {
        container_id: this.id,
        pageLayoutId: parentId
      }, true)

      let newIds = parentId.split("_")
      newIds.splice(newIds.length - 1, 1)
      if (newIds.length > 0) {
        newIds = newIds.join("_")
        this.setParentLayoutH(newIds, lastIndex)
      }
    },
    // 重新计算整个通栏每层 每个格子的高度
    reSetLayoutH(pageLayoutIds, curLayoutH) {
      let curLevel = pageLayoutIds.length
      let curIndex = parseInt(pageLayoutIds[pageLayoutIds.length - 1])
      let parentIndex = parseInt(pageLayoutIds[pageLayoutIds.length - 2])
      if (curLevel === 0) {
        return
      }
      // 重新获取父级布局
      let parentLayout = this.getParentLayout(pageLayoutIds)
      let curCellIsRow = parentLayout.layout.rows.length > 0 ? true : false
      let curPagelayout = curCellIsRow ? parentLayout.layout.rows[curIndex] : parentLayout.layout.cols[curIndex]
      let parentLayoutH = 0
      let editProp = curLayoutH / curPagelayout.options.height
      if (curCellIsRow) {
        parentLayout.layout.rows.forEach((item, index) => {
          if (index === curIndex) {
            item.options.height = curLayoutH
          } else {
            item.options.height = item.options.height * editProp
            this.setChildLayoutH(editProp, item)
          }
          parentLayoutH += parseFloat(item.options.height)
        })
      } else {
        parentLayout.layout.cols.forEach((item, index) => {
          item.options.height = curLayoutH
          if (index !== curIndex) {
            this.setChildLayoutH(editProp, item)
          }
        })
        parentLayoutH = curLayoutH
      }
      pageLayoutIds.splice(pageLayoutIds.length - 1, 1)
      return this.reSetLayoutH(pageLayoutIds, parentLayoutH)
    },
    getParentLayout(pageLayoutIds) {
      let newPageLayoutId = JSON.parse(JSON.stringify(pageLayoutIds))
      newPageLayoutId.splice(pageLayoutIds.length - 1, 1)
      newPageLayoutId = newPageLayoutId.join("_")
      return this.getAttrById.call(
        this,
        this.$store.state[this.request_prefix],
        { container_id: this.ids.container_id, pageLayoutId: newPageLayoutId },
        "pageLayout"
      )
    },
    // 拖入应用之后改变外层壳子的尺寸 不影响其他单元格的情况才改变
    // 上述情况改为 拖入应用都撑大 其他单元格（兄弟列）等比方法
    changeCellSize(width, height) {
      if (this.request_prefix === "bigScreen") {
        // 大屏的格子高度不随组件改变
        return
      }
      // if (this.layoutLevel === 2 && this.parentLayout.rows.length === 0) {
      //   return
      // }
      let ultimateHeight,
        curCellIsCol = this.parentLayout.cols && this.parentLayout.cols.length > 0 ? true : false
      if (!width) {
        // this.col.options.height = Math.max(height ,this.col.options.height)
        ultimateHeight = curCellIsCol ? Math.max(height, this.col.options.height) : height
        // this.col.options.height = height
      } else {
        ultimateHeight = curCellIsCol ? (this.$el.getBoundingClientRect().width / this.zoom) * (height / width) : height
        ultimateHeight = Math.max(ultimateHeight, this.col.options.height)
        // this.col.options.height = ultimateHeight
      }
      // 如果当前为col  兄弟元素的高度一起撑高
      if (curCellIsCol) {
        this.parentLayout.cols.forEach((layout, index) => {
          layout.options.height = ultimateHeight
        })
      } else {
        this.parentLayout.rows.forEach((layout, index) => {
          if (index === this.curIndex) {
            layout.options.height = ultimateHeight
          }
        })
      }
      // 当高度大于父元素高度的时候，单独处理
      let layoutIds = this.layoutIndex.toString().split("_")
      let parentId = JSON.parse(JSON.stringify(layoutIds))
      parentId.splice(layoutIds.length - 1, 1)
      parentId = parentId.join("_")
      this.setParentLayoutH(parentId, this.curIndex)
    },
    boxShadowStyle(options) {
      let tmpStyle = ""
      if (!options.boxShadowH || options.boxShadowH.length === 0) {
        return
      }
      if (Array.isArray(options.boxShadowH)) {
        options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${options.boxShadowH[index]}px ${options.boxShadowV[index]}px ${options.boxShadowBlur[index]}px ${options.boxShadowSpread[index]}px ${this.$parseColor(options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${options.boxShadowH}px ${options.boxShadowV}px ${options.boxShadowBlur}px ${options.boxShadowSpread}px ${this.$parseColor(options.boxShadowColor)}`
      }
      return tmpStyle
    },
    activeLayoutCell(el, type) {
      console.log("activeLayoutCell")
      let target = $(el.target)
      // 判断当前选中dom的祖先元素是否有.customDrawer
      if (target.parents(".customDrawer").length > 0) {
        return
      }
      if (type === "resize") {
        target.siblings(".layout-sets").find(".default-icon").click()
      } else {
        target.parents(".layout-columns").siblings(".layout-sets").find(".default-icon").click()
      }
      // this.offsetTop = this.$el.getBoundingClientRect().top - 50
    },
    // 获取当前快照
    getQuickShot() {
      const { container_id, rect_id } = this.ids
      const page = this.$store.state[this.request_prefix].page
      const rect = page.children[0].children.find(rect => rect.rect_id === rect_id)
      return deepCloneAndFreeze(rect)
    }
  }
}
</script>

<style  scoped>
::v-deep .layout-col,
::v-deep .layout-row {
  position: relative;
  box-sizing: border-box;
  z-index: 1;
}
.layout-col.zIndex999  .resize_handle,
.layout-row.zIndex999 .resize_handle {
  /* 布局聚焦模式，布局内的cell-focus-shade层级太高（10000000），方便拖拽布局的高度*/
  z-index: 10000001;
}
.layout-row__container {
  display: flex;
  text-align: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  overflow: visible;
  width: 100%;
}
.icon.add-col {
  position: absolute;
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  top: 50%;
  right: -9px;
  margin-top: -9px;
  z-index: 9999;
  cursor: pointer;
}
.layout-row-container,
.layout-col-container {
  position: relative;
  display: flex;
  text-align: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  overflow: visible;
  width: 100%;
  height: 100%;
  /*justify-content: center;*/
}
.layout-container {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: visible;
}
.layout-row-container {
  flex-wrap: wrap;
}
.layout-columns {
  justify-content: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  /* -webkit-box-orient: vertical; */
  /* -webkit-box-direction: normal; */
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
  will-change: flex, max-width;
  height: 100%;
  overflow: visible;
  /*outline: 1px dashed rgba(0, 0, 0, 0.4);*/
  box-sizing: border-box;
}
.layout-row {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: left;
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
  max-width: 100%;
  width: 100%;
  overflow: visible;
}
.drag-handle-left {
  position: absolute;
  z-index: 10;
  width: 20px;
  height: 100%;
  left: -10px;
  background-color: green;
  cursor: ew-resize;
}
.drag-handle-right {
  position: absolute;
  z-index: 10;
  width: 20px;
  height: 100%;
  right: -10px;
  background-color: green;
  cursor: ew-resize;
}
.auto-layout-container {
  position: relative;
  overflow: hidden;
  min-width: 20px;
  min-height: 20px;
  outline: 1px solid var(--themeColor);
}
.padding-block {
  position: absolute;
  left: 0;
  right: 0;
  cursor: ns-resize;
  background-color: transparent;
  z-index: 1;
  font-size: 0;
  color: var(--themeColor);
}

.padding-block.active {
  font-size: 14px;
  background-color: rgba(43, 103, 255, 0.12);
}

.padding-block-top {
  top: 0;
}
.padding-block-bottom {
  bottom: 0;
}

::v-deep.layout-box.active {
  border-color: var(--themeColor);
}
::v-deep.layout-container.active > .layout-sets .cell-sets,
::v-deep.layout-container.set_active > .layout-sets .cell-sets {
  display: inline-block;
}
/*栅格模式下，栅格悬浮的时候，不展示根布局的工具栏*/
::v-deep.layout-container.parent-unActive:not(.set_active)> .layout-sets .cell-sets{
  display: none;
}
::v-deep.layout-container.set_active > .layout-sets .cell-sets:not(.has-position) .submover {
  display: inline-block;
}
::v-deep.layout-container.set_active > .layout-sets .cell-sets:not(.has-position) .default-icon {
  display: none;
}
::v-deep.layout-container.set_active > .layout-sets .cell-sets-toolbar {
  display: inline-block;
  top: -50px;
  opacity: 1;
  z-index: 1;
  height: 34px;
  width: auto;
  overflow: unset;
}
::v-deep.layout-container.set_active > .layout-sets .cell-sets-toolbar.isBottom {
  top: 30px;
}
.layout-container.active > .resize_handle,
.layout-container.set_active > .resize_handle,
.layout-container.active:hover > .resize_handle {
  display: block;
}
.layout-row > .layout-container.active:hover > .resize-handle-bottom,
.layout-row > .layout-container.set_active > .resize-handle-bottom {
  display: block;
}
.default-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  border-radius: 50%;
  transition: all 0.1s;
}

.default-icon:hover {
  transform: scale(1.3);
}
.mover,
.submover {
  display: none;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  border-radius: 50%;
  transform: scale(1.3);
  cursor: move;
}
.resize_handle {
  position: absolute;
  display: none;
  z-index: 9999;
  background-color: transparent;
  width: 10px;
  height: 100%;
  top: 0;
  cursor: ew-resize;
}
.resize_handle:before {
  position: absolute;
  content: "";
  width: 6px;
  height: 24px;
  top: 50%;
  left: 16%;
  transform: translateY(-50%);
  border-radius: 20px;
  z-index: 9999;
  background-color: var(--themeColor);
}
.resize_handle .size {
  position: absolute;
  /*display: none;*/
  padding: 8px 12px;
  left: 0;
  top: -40px;
  transform: translateX(-50%);
  background-color: var(--tipsBgColor);
  /*color: var(--thirdTextColor);*/
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  border-radius: 4px;
  word-break: keep-all;
  width: 100px;
  margin-left: 5px;
}
.resize_handle .size.is-bottom {
  top: 10px;
}
.resize_handle .size.is-down {
  top: calc(100% + 6px);
}
.resize_handle .size:before {
  display: block;
  content: "";
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: var(--tipsBgColor) transparent transparent;
}
.resize_handle .size.is-bottom:before,
.resize_handle .size.is-down:before {
  top: -12px;
  bottom: auto;
  border-color: transparent transparent var(--tipsBgColor);
}
.resize_handle .split-line {
  color: var(--alertBackGround);
  margin: 0 4px;
}
.resize-handle-left {
  left: -4px;
}
.resize-handle-right {
  right: -4px;
}
.resize-handle-bottom {
  width: 100%;
  height: 10px;
  left: 0;
  bottom: -3px;
  top: unset;
  cursor: ns-resize;
}
.resize_handle.resize-handle-bottom:before {
  top: 6px;
  left: 50%;
  margin-left: -12px;
  width: 24px;
  height: 6px;
}
.handle-tb,
.handle-rb,
.handle-bb,
.handle-lb {
  display: none;
}
.layout-container-waterFlow .handle-tb,
.layout-container-waterFlow .handle-rb,
.layout-container-waterFlow .handle-bb,
.layout-container-waterFlow .handle-lb{
  display: block;
  border-color: var(--thirdTextColor) ;
}
.layout-container-waterFlow.active .handle-tb,
.layout-container-waterFlow.active .handle-rb,
.layout-container-waterFlow.active .handle-bb,
.layout-container-waterFlow.active .handle-lb{
  display: block;
  border-color: var(--themeColor) ;
}
.layout-container-waterFlow.parent-unActive .handle-tb,
.layout-container-waterFlow.parent-unActive .handle-rb,
.layout-container-waterFlow.parent-unActive .handle-bb,
.layout-container-waterFlow.parent-unActive .handle-lb{
  display: block;
  border-color: var(--thirdTextColor) ;
}
.layout-container.active > .handle-tb,
.layout-container.active > .handle-rb,
.layout-container.active > .handle-bb,
.layout-container.active > .handle-lb {
  display: block !important;
}
.layout-container.set_active > .handle-tb,
.layout-container.set_active > .handle-bb {
  /* height: 2px; */
  border-top: 2px dashed var(--themeColor);
  display: block !important;
}
.layout-container.set_active > .handle-rb,
.layout-container.set_active > .handle-lb {
  /* width: 2px; */
  border-left: 2px dashed var(--themeColor);
  display: block !important;
}
/* 通栏隐藏时需要宽度 不然编辑器里的视频渲染不出来 */
.hidden {
  visibility: hidden;
  height: 0 !important;
  width: 0px !important;
  border: 0 !important;
}
/* 悬浮和选中时取消默认虚线边框 */
.layout-container.set_active > .layout-columns,
.layout-container.active > .layout-columns {
  outline: none !important;
}
/* 产品提的 悬浮布局大于选中布局 */
/* .layout-container.active {
  z-index: 2;
} */
.transition {
  transition: all 0.4s ease-in-out;
}
</style>
